import { Trans } from '@lingui/macro'
import classNames from 'classnames'

import { VoucherHeaderProps } from './VoucherHeader'
import styles from './vouchers.module.scss'
import Heading from '../typography/Heading'

export const VoucherCartHeader = (props: VoucherHeaderProps) =>
    props.numberOfVouchers > 0 ? (
        <div className={classNames(styles.header, styles.marginBottom)}>
            <div className={styles.loaderContainer}>
                <Heading variant="h2" element="h3">
                    <Trans id="user.rewards.vouchersHeading">
                        My rewards vouchers
                    </Trans>
                </Heading>
                {props.children}
            </div>
        </div>
    ) : null
